import React, {useState, useContext} from 'react'
import CIcon from "@coreui/icons-react";
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CInput,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CRow
} from "@coreui/react";

import {Login as apiLogin, forgotPassword} from '../../common/apiCalls/index'
import {APIErrorAlert, FormAlert} from '../components/index'
import {AlertTypes} from '../../common/enums/index'
import {AppStateHandlersContext} from '../../App'

const Login = ()=> {
  
   const appStateHandlers = useContext(AppStateHandlersContext)

   const [localState,setLocalState]=useState(
      {
         username:'',
         password:'',
         validationError:'',
         error:''
      }
   )

   const handleForgotPassword=()=>{
      if(localState.username===""){
         setLocalState(
         {
            ...localState,
            validationError: "Enter username",
         });
      }else{
         async function doForgot() {
            try {
                  const response = await forgotPassword(localState.username);
                  if(response.status.code===200){
                     appStateHandlers.handleAppHistory("/billpaymis/resetpassword");
                     appStateHandlers.handleAuth(false)
                  }else{
                     setLocalState({
                           ...localState,
                           loading:false,
                           error:response.status.message
                        })
                  }
            } catch (error) {
               setLocalState({
                  ...localState,
                  loading:false,
                  error:error.message
               })
            }
         }
         
         doForgot();
      }
   }  

   const handleChange = (e)=>{
      const theName= e.target.name;
      const theValue = e.target.value;
      setLocalState(
         {
            ...localState,
            [theName]:theValue,
            validationError:'',
            error:''
         }
      );
   }

   const handleLogin = ()=>{
      if(localState.username==="" || localState.password===""){
         setLocalState(
            {
               ...localState,
               validationError: "Enter both username and password",
            });
      }else{
         async function doLogin() {
            try {
               const response = await apiLogin(localState.username,localState.password);
               if(response.status.code===200){
                  appStateHandlers.handleAuth(true,response.data)
               }else{
                  setLocalState({
                     ...localState,
                     error:response.status.message
                  })
               }
            } catch (error) {
               setLocalState({
                  ...localState,
                  error:error.message
               })
            }
         }
         doLogin();
      }
   }
  
   return (<div className="c-app c-default-layout flex-row align-items-center">
         <CContainer>
            <CRow className="justify-content-center">
               <CCol md="6">
                  <CCardGroup>
                     <CCard className="p-4">
                     <CCardBody>
                        <CForm>
                           <APIErrorAlert error={localState.error} type={AlertTypes.Alert_Danger}/>
                           <h1>Login</h1>
                           <p className="text-muted">to Bill Payment Service MIS</p>
                           <CInputGroup className="mb-3">
                           <CInputGroupPrepend>
                              <CInputGroupText>
                                 <CIcon name="cil-user" />
                              </CInputGroupText>
                           </CInputGroupPrepend>
                           <CInput
                              autoFocus
                              type = "text"
                              name = "username"
                              placeholder = "Username"
                              autoComplete = "username"
                              onChange={handleChange}
                           />
                           </CInputGroup>
                           <CInputGroup className="mb-4">
                           <CInputGroupPrepend>
                              <CInputGroupText>
                                 <CIcon name="cil-lock-locked" />
                              </CInputGroupText>
                           </CInputGroupPrepend>
                           <CInput
                              type = "password"
                              name = "password"
                              placeholder = "Password"
                              autoComplete = "current-password"
                              onChange = {handleChange}
                           />
                           </CInputGroup>
                           <FormAlert error={localState.validationError} type={AlertTypes.Alert_Warning}/>
                           <CRow>
                           <CCol xs="6">
                              <CButton
                                 color="primary"
                                 className="px-4"
                                 onClick={handleLogin}
                              >
                                 Login
                              </CButton>
                           </CCol>
                           <CCol xs="6" className="text-right">
                              {
                                 localState.username?
                                 <CButton 
                                    color="link" 
                                    className="px-0"
                                    onClick={handleForgotPassword}
                                 >
                                    Forgot password?
                                 </CButton>
                                 :null
                              }
                           </CCol>
                           </CRow>
                        </CForm>
                     </CCardBody>
                     </CCard>
                  </CCardGroup>
               </CCol>
            </CRow>
         </CContainer>
      </div>
   )

}

export default Login;